import React from 'react';
import { ContentfulArticle } from '@jbhi-fi/apis/src/contentful/types';
import { CardCoverImage } from '../../Card';
import { CardGridCardProps } from '../../Card/CardGrid/CardGrid';
import { format, parseISO } from 'date-fns';
import { CardTransformer } from './CardTransformer';
import { MiniCardProps } from '../../MiniCard/MiniCard';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { AssetTransformer } from './AssetTransformer';

export abstract class ArticleTransformer {
  static toCardProps = (entry?: ContentfulArticle): CardGridCardProps => {
    const isVideoCard = !!entry?.fields?.heroVideo?.fields;
    const coverImageProps = CardTransformer.toCardCoverImageProps(entry);
    const publishedDate = entry?.fields?.publishedDate || entry?.sys?.createdAt;
    return {
      heading: entry?.fields?.heading,
      content: !isVideoCard ? entry?.fields?.intro : null,
      cover: coverImageProps ? <CardCoverImage {...coverImageProps} /> : null,
      tagProps: CardTransformer.toTagProps(entry),
      footerProps: {
        leftContent: publishedDate ? format(parseISO(publishedDate), 'd MMM yyyy') : '',
        rightContent: entry?.fields?.parentPage?.fields?.heading,
      },
      showTag: false,
      href: CardTransformer.toHref(entry),
    };
  };

  static toMiniCardProps = (entry?: ContentfulArticle): MiniCardProps => {
    const coverImage = entry?.fields?.heroImage || entry?.fields?.heroVideo?.fields?.landscapeCoverImage;
    const coverImageProps = AssetTransformer.toContentfulImageProps(coverImage);
    return {
      title: entry?.fields?.heading || '',
      image: <ContentfulImage {...coverImageProps} sizes="80px" aspectRatio={1} />,
      destinationUrl: CardTransformer.toHref(entry),
    };
  };
}
